// @generated
// This file was automatically generated and should not be edited.
// Run `dev generate pipeline-frontend` to regenerate.

/* eslint-disable unused-imports/no-unused-imports */

// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {ColumnTypeValidationFlag} from 'data-frames/util/validateColumnType';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {LeafType} from 'data-types/benchling-type-def/BenchlingTypeDef';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {PipelineStepDataKind, PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {PipelineStepShape} from 'pipelines/StepShapeUtils';

export const MAP_JSON_TO_DATASETS_AND_FILES_STEP_SHAPES = [
  {
    stepType: PipelineStepType.MAP_JSON_TO_DATASETS_AND_FILES,
    isDeprecated: false,
    version: 0,
    inputDataShapes: {
      'Input file': {
        systemName: 'Input file',
        displayName: 'Input file',
        kind: PipelineStepDataKind.FILE,
        isMulti: false,
        isRequired: true
      }
    },
    outputDataShapes: {
      'Output files': {
        systemName: 'Output files',
        displayName: 'Output files',
        kind: PipelineStepDataKind.FILE,
        isMulti: true,
        isRequired: false
      },
      'Output datasets': {
        systemName: 'Output datasets',
        displayName: 'Output datasets',
        kind: PipelineStepDataKind.DATASET,
        isMulti: true,
        isRequired: false
      }
    },
    config: {
      datasets: {
        kind: 'array',
        required: true,
        elementSpec: {
          kind: 'shape',
          required: true,
          fields: {
            name: {
              kind: 'string',
              required: true
            },
            columns: {
              kind: 'array',
              required: true,
              elementSpec: {
                kind: 'shape',
                required: true,
                fields: {
                  name: {
                    kind: 'string',
                    required: true
                  },
                  path: {
                    kind: 'string',
                    required: true
                  },
                  include: {
                    kind: 'boolean',
                    required: true
                  },
                  required: {
                    kind: 'boolean',
                    required: true
                  }
                }
              },
              minItems: 1
            },
            include: {
              kind: 'boolean',
              required: true
            },
            is_metadata: {
              kind: 'boolean',
              required: true
            }
          }
        },
        minItems: 1
      },
      transforms: {
        kind: 'array',
        required: false,
        elementSpec: {
          kind: 'taggedUnion',
          required: true,
          tagKey: 'type',
          choices: [
            {
              kind: 'shape',
              required: true,
              fields: {
                type: {
                  kind: 'string',
                  required: true,
                  value: 'JOIN'
                },
                dataset_1: {
                  kind: 'string',
                  required: true
                },
                dataset_2: {
                  kind: 'string',
                  required: true
                },
                join_key_1: {
                  kind: 'string',
                  required: true
                },
                join_key_2: {
                  kind: 'string',
                  required: true
                }
              }
            },
            {
              kind: 'shape',
              required: true,
              fields: {
                type: {
                  kind: 'string',
                  required: true,
                  value: 'PIVOT'
                },
                dataset: {
                  kind: 'string',
                  required: true
                },
                path: {
                  kind: 'string',
                  required: true
                },
                value_path: {
                  kind: 'string',
                  required: true
                },
                label_path: {
                  kind: 'string',
                  required: true
                }
              }
            }
          ]
        }
      }
    }
  }
] as const satisfies ReadonlyArray<PipelineStepShape>;
